import React, { memo, forwardRef } from "react";
const SvgComma = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M16.66 28.64c-.147.44-.327.713-.54.82-.213.12-.42.18-.62.18-.307 0-.567-.093-.78-.28-.213-.187-.32-.447-.32-.78v-.22c.013-.107.047-.24.1-.4l.86-2.92c.133-.453.32-.74.56-.86.24-.12.453-.18.64-.18.307 0 .573.1.8.3.24.2.36.46.36.78a1.795 1.795 0 01-.12.62l-.94 2.94z"
      />
    </svg>
  );
});
SvgComma.displayName = "SvgComma";
const MemoForwardRef = memo(SvgComma);
export default MemoForwardRef;
